import template from './template.html';
import blockBase from "../../mixins/blockBase";

export default {
    name: 'faq',
    template: template,
    mixins: [
        blockBase,
    ],
    computed: {
        fields() {
            return this.$store.getters.getAcfOptionField('clients');
        }
    }
};